import type { SVGProps } from 'react';

export const ChevronRight = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 16" {...props}>
      <path
        d="M5.76332 2.26555C6.11479 1.91408 6.68464 1.91409 7.03611 2.26556L12.0631 7.29262C12.4536 7.68315 12.4536 8.31631 12.0631 8.70683L7.0342 13.7357C6.68273 14.0872 6.11288 14.0871 5.76141 13.7357C5.40993 13.3842 5.40994 12.8144 5.76141 12.4629L10.2246 7.99971L5.7633 3.53834C5.41183 3.18687 5.41184 2.61702 5.76332 2.26555Z"
        fill="#currentColor"
      />
    </svg>
  );
};
